var Slides = function () {

    var $elements = {}

    var setElements = function () {
        $elements = {
            doctors: $('.js-doctors-slide'),
            doctors2: $('.js-doctors2-slide')
        }
    }

    var loadJS = function () {
        UL.getScriptCdn(
            '//cdn.jsdelivr.net/jquery.slick/1.6.0/slick.min.js',
            config.bowerPath + 'slick-carousel/slick/slick.min.js',
            loadCSS
        );
    };

    var loadCSS = function () {
        UL.getScriptCdn(
            '//cdn.jsdelivr.net/jquery.slick/1.6.0/slick.css',
            config.bowerPath + 'slick-carousel/slick/slick.css',
            initSliders
        );
    };

    var initSliders = function () {
        var addCustomArrow = function (slick, direction, css) {
            $slick = $(slick.currentTarget);
            var $btn = $('<button></button>')
                .addClass('m-btn-nav ul-' + css + '-open')
                .click(function () {
                    $slick.slick(direction);
                });

            var $nav = $slick.find('.slick-dots');

            if (direction == 'slickPrev') {
                $nav.prepend($btn)
            } else {
                $nav.append($btn)
            }
        };

        var doctors = function () {
            if ($elements.doctors.length) {
                ($elements.doctors)/*.on('init', function (slick) {
                    addCustomArrow(slick, 'slickPrev', 'left');
                    addCustomArrow(slick, 'slickNext', 'right');
                })*/.slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true
                });
            }
        }();

        var doctors2 = function () {
            if ($elements.doctors2.length) {
                ($elements.doctors2).slick({
                    infinite: true,
                    arrows: false,
                    speed: 300,
                    slidesToShow: 2,
                    adaptiveHeight: true,
                    centerPadding: '30px',
                    responsive: [
                        {
                            breakpoint: 788,
                            settings: {
                                slidesToShow: 1,
                            }
                    }
                  ]
                });
            }
        }();
    };

    var test = function () {
        if ($elements.doctors.is(':visible')) {
            return true
        } else if ($elements.doctors2.is(':visible')) {
            return true
        } else {
            return false;
        }
    };

    var init = function () {
        setElements();

        if (test()) {
            loadJS();
        }
    };

    return {
        init: init
    };
}();

UL.register(Slides);
